import { useEffect } from 'react';

const CSS_VAR = '--top-banner-offset';

const useTopBannerRegistration = (height: number) => {
  useEffect(() => {
    const root = document.documentElement;
    const current = Number.parseInt(root.style.getPropertyValue(CSS_VAR) || '0', 10);
    root.style.setProperty(CSS_VAR, `${current + height}px`);

    return () => {
      const cur = Number.parseInt(root.style.getPropertyValue(CSS_VAR) || '0', 10);
      root.style.setProperty(CSS_VAR, `${Math.max(0, cur - height)}px`);
    };
  }, [height]);
};

export default useTopBannerRegistration;
